import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getWorkOrdersMaterials: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].GET_WORK_ORDERS_MATERIALS,
	},

	getWorkOrdersMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].GET_WORK_ORDERS_MATERIAL,
	},

	createWorkOrdersMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].CREATE_WORK_ORDERS_MATERIAL,
	},

	putWorkOrdersMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].PUT_WORK_ORDERS_MATERIAL,
	},

	patchWorkOrdersMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].PATCH_WORK_ORDERS_MATERIAL,
	},

	deleteWorkOrdersMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].DELETE_WORK_ORDERS_MATERIAL,
	},
}
